<template>
    <span v-if="items.length">
        <app-button
            secondary
            icon-left="layerGroup"
            :text="$t('change_view')"
            :disabled="disabled"
            @click="dialog = true"
        />

        <app-dialog
            v-if="!disabled"
            v-model="dialog"
            size="x-large"
            hide-actions
            :persistent="false"
            :overline="$t('display_options')"
            :title="$t('change_view')"
            :text="`${$t('select_one_of_the_following')} ${$t('display_options')}`"
        >
            <app-item-group
                v-model="display"
                :items="items"
                class="px-3 pt-0 pb-5 text-center"
                @input="dialog = false"
            />
        </app-dialog>
    </span>
</template>

<script>
export default {
    name: 'DisplayButton',
    components: {
        AppDialog: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppDialog'
            ),
        AppItemGroup: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppItemGroup'
            )
    },
    props: {
        value: {
            type: String,
            default: 'table' // table, cards, kanban
        },
        allowed: {
            type: Array,
            default: () => ['table', 'cards']
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        dialog: false
    }),
    computed: {
        display: {
            get() {
                if (!this.value && this.allowed.includes(this.$store.getters['preferences/table_display_format'])) {
                    return this.$store.getters['preferences/table_display_format'];
                }

                return this.value;
            },
            set(v) {
                this.$store.dispatch('preferences/setTableDisplayFormat', v);
                this.$emit('input', v);
            }
        },
        items() {
            const items = [
                {
                    id: 'table',
                    heading: this.$t('table'),
                    icon: this.getIcon('table', 'fad')
                },
                {
                    id: 'cards',
                    heading: this.$t('cards'),
                    icon: this.getIcon('cards', 'fad')
                },
                {
                    id: 'kanban',
                    heading: this.$t('kanban'),
                    icon: this.getIcon('kanban', 'fad')
                }
            ];

            return items.filter(i => this.allowed.includes(i.id));
        }
    }
};
</script>
